import React, { useState, useImperativeHandle } from "react";
import { useFormik, FormikProvider, FieldArray } from "formik";

// components
import InputField from "../../../components/forms/InputField/InputField.component";
import FormSectionHeader from "../../../components/forms/FormSectionHeader/FormSectionHeader.component";
import AsyncSelectField from "../../../components/forms/AsyncSelectField/AsyncSelectField.component";
import ActionButton from "../../../components/buttons/ActionButton/ActionButton.component";
import PurchaseOrderEquipmentInput from "../../../components/forms/lists/PurchaseOrderEquipmentInput/PurchaseOrderEquipmentInput.component";

// mui
import { Grid } from "@mui/material";

// queries
import { GET_ALL_EQUIPMENT_FOR_SELECT_FIELD } from "../../../graphql/equipment/equipment.queries";
import { GET_ALL_JOBS_FOR_SELECT_FIELD } from "../../../graphql/job/job.queries";

// utils
import { cleanItemsForPrefill } from "./EditPurchaseOrder.form.utils";

const EditPurchaseOrder = React.forwardRef(
  ({ prefillData = null, errors }, ref) => {
    useImperativeHandle(ref, () => ({
      getData: () => {
        return formik.values;
      },
    }));

    const [selectedEquipment, setSelectedEquipment] = useState(null);

    const formik = useFormik({
      initialValues: prefillData
        ? {
            ...prefillData,
            deleteItems: [],
            orderItems: cleanItemsForPrefill(prefillData.orderItems),
          }
        : {
            vendorName: "",
            number: "",
            orderDate: "",
            job: "",
            orderItems: [],
            equipmentSearch: "",
          },
      onSubmit: (values) => {
        alert(JSON.stringify(values, null, 2));
      },
    });

    return (
      <FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit}>
          <FormSectionHeader text="Vendor" />
          <InputField
            id="vendorName"
            placeholder="Vendor Name"
            type="text"
            onChange={formik.handleChange}
            value={formik.values.vendorName}
            isValid={errors["vendorName"]}
          />

          <InputField
            id="number"
            placeholder="PO #"
            type="text"
            onChange={formik.handleChange}
            value={formik.values.number}
            isValid={errors["number"]}
          />

          <InputField
            id="orderDate"
            placeholder="Date"
            type="date"
            onChange={(value) => formik.setFieldValue("orderDate", value)} // ✅ FIXED - added the value
            value={formik.values.orderDate}
            isValid={errors["orderDate"]}
          />

          <AsyncSelectField
            id="job"
            value={formik.values.job}
            placeholder="Job"
            onChange={(value) => formik.setFieldValue("job", value.value)}
            query={{
              query: GET_ALL_JOBS_FOR_SELECT_FIELD,
              rules: {
                loopField: "allJobs",
                label: ["name"],
                value: "id",
              },
            }}
            required={false}
          />

          <FieldArray
            name="orderItems"
            render={({ remove, push }) => (
              <div>
                <FormSectionHeader text="Equipment" />

                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={10}>
                    <AsyncSelectField
                      id="equipmentSearch"
                      value={formik.values.equipmentSearch}
                      placeholder="Select Equipment..."
                      onChange={(value) => {
                        setSelectedEquipment(value.data);
                        formik.setFieldValue("equipmentSearch", value.value);
                      }}
                      query={{
                        query: GET_ALL_EQUIPMENT_FOR_SELECT_FIELD,
                        rules: {
                          loopField: "allEquipment",
                          label: ["sku", "name"],
                          value: "id",
                          groupBy: "category.name",
                        },
                      }}
                      grouped
                      required={false}
                    />
                  </Grid>
                  <Grid container item xs={2}>
                    <ActionButton
                      sx={{ width: "100%", marginBottom: 2 }}
                      label="Add"
                      disabled={selectedEquipment == null}
                      onClick={(e) => {
                        e.preventDefault();
                        push({
                          equipment: { ...selectedEquipment },
                          quantity: "",
                          price: "",
                          id: null,
                        });
                      }}
                    />
                  </Grid>
                </Grid>

                {formik.values.orderItems.map((item, index) => {
                  return (
                    <PurchaseOrderEquipmentInput
                      key={index}
                      prefix={`orderItems.${index}`}
                      handleChange={formik.handleChange}
                      name={item.equipment.name}
                      category={
                        item.equipment && item.equipment.category
                          ? item.equipment.category.name
                          : null
                      }
                      quantity={item.quantity}
                      price={item.price}
                      handleRemove={(e) => {
                        e.preventDefault();
                        let newDeletes = [...formik.values.deleteItems];
                        if (item.id) {
                          newDeletes.push(item.id);
                        }
                        formik.setFieldValue("deleteItems", newDeletes);
                        remove(index);
                      }}
                      errors={
                        errors["orderItems"].length > index
                          ? errors["orderItems"][index]
                          : {}
                      }
                    />
                  );
                })}
              </div>
            )}
          />
        </form>
      </FormikProvider>
    );
  }
);

export default EditPurchaseOrder;
